// extracted by mini-css-extract-plugin
export default {"btnWrapper":"style_btnWrapper__LeQLs","content":"style_content__Hdy1U","icon":"style_icon__bJbSu"};